import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'

class AreaChartPanel extends Component {
  render() {
    let data = this.props.data;
    let total = 0;
    data.forEach(element => {
      total += element.Value;
    });

    return (
      <div>
        <div className="title">{this.props.title}</div>
        <div className="row" >
          <div style={{ width: "100%", textAlign: "right", marginRight: "10px" }}>
            Total <span style={{ display: "inline-block", minWidth: "40px", textAlign: "right" }}>{total}</span>
          </div>
        </div>
        {data[0] &&
          <div className="row">
            <ResponsiveContainer width="100%" height={160}>
              <AreaChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 10 }}>
                <XAxis dataKey="Key" width={1} />
                <YAxis />
                <CartesianGrid strokeDasharray="2 2" />
                <Tooltip cursor={{ stroke: 'none', fill: 'none' }} />
                <Area
                  type="monotone"
                  dataKey="Value"
                  activeDot={{ r: 8 }}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        }
        {!data[0] &&
          <div className="row">
            <div style={{ width: "100%", textAlign: "center" }}>
              No data to show
              </div>
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(AreaChartPanel)